module.exports = __webpack_public_path__ + "static/media/n_member_active.035c009e.png";